import React, { useEffect, useState } from 'react';
import BookingView from '../booking-view/BookingView';

const Booking = () => {

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768); // Bootstrap "md" breakpoint
        };

        checkMobile(); // initial check
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);


    return (
        <div className="container-scroller">
            <div className="container-fluid page-body-wrapper full-page-wrapper">
                <div className="row w-100 m-0">
                    <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
                        <div className="card col-lg-6 mx-auto">
                            <div className={`${!isMobile ? 'card-body px-5 py-5' : ''}`}>
                                <BookingView />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default Booking;
